import { render, staticRenderFns } from "./CommonSpeakingKtResult.vue?vue&type=template&id=4e15d78c&scoped=true"
import script from "./CommonSpeakingKtResult.vue?vue&type=script&lang=js"
export * from "./CommonSpeakingKtResult.vue?vue&type=script&lang=js"
import style0 from "./CommonSpeakingKtResult.vue?vue&type=style&index=0&id=4e15d78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e15d78c",
  null
  
)

export default component.exports